<template>
  <div>

    <v-data-table
        :headers="headersItems" :items="itemChange"
        :class="'elevation-1 row-pointer ff border'"
        :hide-default-footer="hideFooter"
        style='border: 2px solid black!important'
    >
      <template #body='{ items, headers }'>
        <tbody>
        <tr v-for='(item, index) in items' :key='index'>
          <td v-for='(n,i) in headers' :key='i'>
            <slot v-if="n.value === 'PDF_ID' && isShowPdf">
              <v-tooltip color='blue' bottom>
                <template v-slot:activator='{ on, attrs }'>
                  <v-btn class='mr-6' type='button' icon
                         @click="$emit('clickPdf',item.PDF_ID)"
                         v-bind='attrs'
                         v-on='on'
                  >
                    <v-icon color='blue'>
                      mdi-pdf-box
                    </v-icon>
                  </v-btn>
                </template>
                <span>СКАЧАТЬ И ПЕЧАТЬ</span>
              </v-tooltip>
            </slot>
            <slot v-if="n.value === 'DELETE_ID' && isDelete">
              <v-row>
                <v-col md="6" offset-md="5" offset-sm="5">
                  <oil-modal
                      :value='item.DELETE_ID'
                      tooltipMessage='УДАЛИТЬ'
                      mdiIcon='mdi-delete'
                      :accept="accept"
                  />
                </v-col>
              </v-row>
            </slot>
            <slot v-if="n.value === 'ID' && isUpdate">
              <v-tooltip color='blue' bottom>-->
                <template v-slot:activator='{ on, attrs }'>
                  <v-btn class='mr-6' type='button' icon
                         @click="$emit('clickUpdate',item.ID)"
                         v-bind='attrs'
                         v-on='on'
                  >
                    <v-icon color='blue'>
                      mdi-pen
                    </v-icon>
                  </v-btn>
                </template>
                <span>ИЗМЕНИТЬ</span>
              </v-tooltip>
            </slot>
            <slot v-if="n.value !== 'ID' && n.value !== 'PDF_ID' && n.value !=='DELETE_ID'" :name='n.value'
                  :object='item'
                  :value='item[n.value]'>
              {{ item[n.value] }}
            </slot>
          </td>
        </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>

</template>

<script>
export default {
  components: {
    OilModal: () => import('@/components/helper/form/oil.delete.modal'),
  },
  created() {

  },
  data() {
    return {
      actionKeys: {
        PDF_ID: 'СКАЧАТЬ И ПЕЧАТЬ',
        ID: 'ИЗМЕНИТЬ',
        DELETE_ID: 'УДАЛИТЬ',
      }
    }
  },
  computed: {
    itemChange() {
      return this.items.map(value => {
        return {
          ...value,
          PDF_ID: value.Id,
          ID: value.Id,
          DELETE_ID: value.Id,
        }
      })
    },
    headersItems() {
      const actionKeys = this.actionKeys

      const headers = this.headers.concat(
          Object.entries(actionKeys).map(([key, value]) => {
            return {
              text: value, value: key
            }
          })
      )
      if (this.isShowPdf === false) {
        const head = headers.find(({value}) => value === 'PDF_ID')
        const index = headers.indexOf(head)
        headers.splice(index, 1)
      }
      if (this.isDelete === false) {
        const head = headers.find(({value}) => value === 'DELETE_ID')
        const index = headers.indexOf(head)
        headers.splice(index, 1)
      }
      if (this.isUpdate === false) {
        const head = headers.find(({value}) => value === 'ID')
        const index = headers.indexOf(head)
        headers.splice(index, 1)
      }
      return headers
    }
  },
  props: {
    items: Array,
    headers: Array,
    hideFooter: {
      type: Boolean,
      default: () => false
    },
    primaryKey: {
      type: String,
      default: () => 'Id'
    },
    isUpdate: {
      type: Boolean,
      default: () => true
    },
    isDelete: {
      type: Boolean,
      default: () => true
    },
    isShowPdf: {
      type: Boolean,
      default: () => true
    },
  },
  methods: {
    accept(id) {
      this.$emit('clickDelete', id)
    }
  }
}
</script>

<style lang='css' scoped>
.row-pointer >>> tbody {
  text-align: center !important;
  font-weight: bold !important;
}

.row-pointer >>> tbody:hover {
  cursor: pointer !important;
}

.row-pointer >>> thead tr th {
  font-weight: bolder !important;
  text-shadow: 0 0 1px black !important;
  font-size: 14px !important;
  text-transform: uppercase !important;
  position: relative;
  text-align: center !important;
  padding: 0 50px !important;
}

.row-pointer >>> thead {
  padding: 10px !important;
  outline: 3px solid black !important;
}

.row-pointer >>> thead tr th :after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: 50% !important;
  top: 0;
  height: 1500px !important;
  border-left: 2px solid grey !important;
  z-index: 1;
}

.row-pointer >>> thead tr th {
  opacity: 1;
}

</style>
